<template>
  <section class="home-for-you-container">
    <h2 class="home-title">서베이지는 이런 분들이 사용하면 좋아요</h2>

    <div class="for-you-grid">
      <div class="for-you-card" v-for="(item, idx) in audienceList" :key="idx">
        <span class="for-you-icon" v-html="item.icon" aria-hidden="true"></span>
        <div class="for-you-title">{{ item.title }}</div>
        <p class="for-you-desc">{{ item.desc }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeForYou',

  data() {
    return {
      audienceList: [
        {
          title: '대학생',
          desc: '과제와 프로젝트를 위해 설문 응답이 필요한 분',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10L12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5"/></svg>'
        },
        {
          title: '대학원생',
          desc: '연구 논문을 위해 설문 응답이 필요한 분',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z"/></svg>'
        },
        {
          title: '스타트업 · 기업',
          desc: '시장조사가 필요한 팀',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09Z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2Z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>'
        }
      ]
    }
  }
}
</script>

<style scoped>
.home-for-you-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.for-you-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.for-you-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-8) var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  text-align: center;
}

.for-you-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: var(--green-500);
}

.for-you-icon svg {
  width: 100%;
  height: 100%;
}

.for-you-title {
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-heading);
}

.for-you-desc {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.6;
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .for-you-grid {
    grid-template-columns: 1fr;
  }
}
</style>
